import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Row, Col, Card, CardHeader, CardTitle, CardBody, CardFooter, ButtonGroup, Button, Form, FormGroup, FormText, Label, Input, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { contactRequest } from '../../ContactActions';
import { getLanguagePath } from '../../../Intl/IntlActions';
import { displayErrors } from '../../../Error/ErrorActions';


class ContactForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: (props.user && props.user.firstName) || '',
            lastName: (props.user && props.user.lastName) || '',
            email: (props.user && props.user.email) || '',
            phone: '',
            message: '',
            isProcessing: false,
            isSent: false,
            errorFields: [],
        };

        this.hasErrorField = this.hasErrorField.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleChange(event) {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState(
            { [name]: value },
        );
    }

    hasErrorField(name) {
        return this.state.errorFields && this.state.errorFields.indexOf(name) !== -1;
    }

    handleSubmit(event) {
        event.preventDefault();

        if(this.state.email && this.state.message) {
            this.setState({
                isProcessing: true,
            });

            this.props.dispatch(contactRequest({
                email: this.state.email,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                phone: this.state.phone,
            }, this.state.message)).then(result => {
                this.setState({
                    isProcessing: false,
                });
                if(result) {
                    this.setState({
                        isSent: true,
                    });
                    displayErrors('success', this.props.intl.formatMessage({
                        id: 'alertContactSuccess',
                        defaultMessage: 'Well received!',
                    }));
                } else {
                    displayErrors('error', this.props.intl.formatMessage({
                        id: 'alertContactError',
                        defaultMessage: 'Unable to send your message! Please retry...',
                    }));
                }
            });
        } else {
            const errorFields = [];
            if(!this.state.email) {
                errorFields.push('email');
            }
            if(!this.state.message) {
                errorFields.push('message');
            }
            this.setState({
                errorFields,
            });
        }
    }

    render() {
        return (
            <div>
                {
                    this.state.isSent
                    ? <Alert color="success" className="text-center">
                            <h4><FontAwesome name="thumbs-up-o" /> <FormattedMessage id="alertContactSuccess" defaultMessage="Well received!" /></h4>
                            <Button color="success" outline tag={Link} to={getLanguagePath('/', this.props.intl.locale)}><FontAwesome name="chevron-left" /> <FormattedMessage id="back" defaultMessage="Back" /></Button>
                      </Alert>
                    : <Form onSubmit={this.handleSubmit}>
                        <h2><FormattedMessage id="contactTitle" defaultMessage="Contact us with this form below" /></h2>

                        <h6 className="mt-4"><FormattedMessage id="contactFormIdentityTitle" defaultMessage="Identity" /></h6>
                        <Row noGutters>
                            <Col xs="12" sm="6">
                                <FormGroup className={classnames(this.hasErrorField('firstName') && 'has-danger', 'mr-2', 'mb-2')}>
                                    <Input type="text" name="firstName" id="firstNameField" className={this.hasErrorField('firstName') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'userFirstName', defaultMessage: 'First name' })} value={this.state.firstName} />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className={classnames(this.hasErrorField('lastName') && 'has-danger', 'mr-2', 'mb-2')}>
                                    <Input type="text" name="lastName" id="lastNameField" className={this.hasErrorField('lastName') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'userLastName', defaultMessage: 'Last name' })} value={this.state.lastName} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row noGutters>
                            <Col xs="12" sm="6">
                                <FormGroup className={classnames(this.hasErrorField('email') && 'has-danger', 'mr-2', 'mb-2')}>
                                    <Input type="text" name="email" id="emailField" className={this.hasErrorField('email') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'userEmail', defaultMessage: 'Email' })} value={this.state.email} />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mr-2 mb-2">
                                    <Input type="text" name="phone" id="phoneField" onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'userPhone', defaultMessage: 'Phone' })} value={this.state.phone} />
                                </FormGroup>
                            </Col>
                        </Row>

                        <h6 className="mt-4"><FormattedMessage id="contactFormMessageTitle" defaultMessage="Message" /></h6>
                        <FormGroup className={this.hasErrorField('message') ? 'has-danger' : ''}>
                            <Input type="textarea" name="message" id="messageField" className={this.hasErrorField('message') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} value={this.state.message} placeholder={this.props.intl.formatMessage({ id: 'contactMessage', defaultMessage: 'Message' })} rows="6" />
                        </FormGroup>

                        <FormGroup className="mt-3">
                            <ButtonGroup>
                                {this.props.closeForm ? <Button color="primary" outline onClick={event => this.props.closeForm()}><FontAwesome name="chevron-left" /> <FormattedMessage id="back" defaultMessage="Back" /></Button> : null}
                                <Button color="warning" disabled={!(this.state.email && this.state.message) || this.state.isProcessing}>{this.state.isProcessing ? <FontAwesome name="spinner" spin /> : <FontAwesome name="paper-plane-o" />} <FormattedMessage id="contactSendButton" defaultMessage="Send the message" /></Button>
                            </ButtonGroup>
                        </FormGroup>
                      </Form>
                }
            </div>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        user: store.users.user,
        orders: [],
    };
}

ContactForm.defaultProps = {
    user: null,
    closeForm: null,
};

ContactForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    user: PropTypes.object,
    closeForm: PropTypes.func,
};

export default connect(mapStateToProps)(injectIntl(ContactForm));
